<template>
  <b-modal id="modalItemDetail"
      ref="modalItemDetail"
      centered
      size="lg"
      :cancel-title="$lang.Common.Cancel"
      :title="$lang.PCI.Lpu.Items.Title"
      @ok="onOk">
    <div class="d-flex flex-wrap col-md-12">
      <div class="col-md-2 mb-3">
        <label for="txtUnidade">{{$lang.PCI.Lpu.LabelSequence}}:</label>
        <b-form-input type="text"
            ref="txtSequence"
            v-model="value.sequencia"
            disabled />
      </div>
      <div class="col-md-10 mb-3">
        <label for="txtSequenica">{{$lang.PCI.Lpu.LabelDescription}}:</label>
        <b-form-input name="txtSequencia"
            type="text"
            v-model="value.descricao"
            disabled />
      </div>
      <div class="col-md-4 mb-3">
        <label for="txtUnidade"><small v-if="form.unidade.required">* </small>{{$lang.PCI.Lpu.LabelUnity}}:</label>
        <b-form-input type="text"
            name="txtUnidade"
            ref="txtUnidade"
            :autofocus="true"
            v-model="form.unidade.value"
            :required="form.unidade.required"
            :maxlength="form.unidade.maxlength"
            :state="form.unidade.state"
            lazy
            @update="isChanged = true" />
      </div>
      <div class="col-md-4 mb-3">
        <label for="txtValor"><small v-if="form.valor.required">* </small>{{$lang.PCI.Lpu.LabelValue}}:</label>
        <b-form-input type="number"
            name="txtValor"
            ref="txtValor"
            v-model="form.valor.value"
            :required="form.valor.required"
            :maxlength="form.valor.maxlength"
            :state="form.valor.state"
            lazy
            @update="isChanged = true" />
      </div>
      <div class="col-md-4 mb-3">
        <label for="txtCodigoCliente"><small v-if="form.codigoCliente.required">* </small>{{$lang.PCI.Lpu.LabelClientCode}}:</label>
        <b-form-input type="text"
            name="txtCodigoCliente"
            ref="txtCodigoCliente"
            v-model="form.codigoCliente.value"
            :required="form.codigoCliente.required"
            :maxlength="form.codigoCliente.maxlength"
            :state="form.codigoCliente.state"
            lazy
            @update="isChanged = true" />
      </div>
      <div class="col-md-12 mb-3">
        <label for="txtDescricaoCliente"><small v-if="form.descricaoCliente.required">* </small>{{$lang.PCI.Lpu.LabelClientDescription}}:</label>
        <b-form-textarea :rows="3"
            name="txtDescricaoCliente"
            ref="txtDescricaoCliente"
            v-model="form.descricaoCliente.value"
            :required="form.descricaoCliente.required"
            :maxlength="form.descricaoCliente.maxlength"
            :state="form.descricaoCliente.state"
            lazy
            @update="isChanged = true" />
      </div>
      <div class="col-md-12 mb-3">
        <label for="txtObservation"><small v-if="form.observacao.required">* </small>{{$lang.PCI.Lpu.LabelObservation}}:</label>
        <b-form-textarea :rows="3"
            name="txtObservacao"
            ref="txtObservacao"
            v-model="form.observacao.value"
            :required="form.observacao.required"
            :maxlength="form.observacao.maxlength"
            :state="form.observacao.state"
            lazy
            @update="isChanged = true" />
      </div>
    </div>
    <b-card v-if="form.colunas.value && form.colunas.value.length" class="mb-0" :header="$lang.PCI.Lpu.LabelCustomColumn">
      <div class="row">
        <div class="col-md-6 mb-3" v-for="(coluna, index) in form.colunas.value" :key="index">
          <div class="col-md-12">
            <label for="txtColuna">{{ coluna.lpuColPersonaliz.rotulo }}</label>
            <b-form-input type="text"
                name="txtColuna"
                ref="txtColuna"
                v-model="coluna.conteudo" />
          </div>
        </div>
      </div>
    </b-card>
</b-modal>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import Form from './addItemDetail-form'
import Data from '@/shared/models/pci/lpuitemdetalhemodel'

export default {
  name: 'AddItemDetail',
  mixins: [ActionsForm],
  data () {
    return {
      form: Form,
      data: Data,
      isChanged: false,
      value: {}
    }
  },
  methods: {
    onLoad () {
    },
    onShow (item, cols) {
      this.isChanged = false
      this.value = item
      this.value.colunas = this.value.colunas || []
      this.value.lpuItemDetalhe = item.lpuItemDetalhe || {}
      this.onEdit(this.value.lpuItemDetalhe)
      this.data.lpuItemID = item.id

      this.value.colunas = this.value.colunas.filter(c => cols.some(c2 => c2.id === c.lpuColPersonalizID))
      this.value.colunas.push(
        ...cols.filter(c => !this.value.colunas.some(c2 => c2.lpuColPersonalizID === c.id)).map(m => {
          return {
            conteudo: '',
            lpuColPersonaliz: m,
            lpuColPersonalizID: m.id,
            lpuItemID: item.id,
            status: 1
          }
        })
      )

      this.form.colunas.value = this.value.colunas || []
      this.$refs.modalItemDetail.show()
    },
    onOk (evt) {
      this.onSave()
      evt.preventDefault()
    },
    onCreate () {
      Object.assign(this.value.lpuItemDetalhe, this.data)
      if (this.isChanged) this.$emit('change')
      this.$emit('ok', this.value)
      this.$nextTick(() => {
        this.$bvModal.hide('modalItemDetail')
        this.onClear()
      })
    },
    onUpdate () {
      Object.assign(this.value.lpuItemDetalhe, this.data)
      if (this.isChanged) this.$emit('change')
      this.$emit('ok', this.value)
      this.$nextTick(() => {
        this.$bvModal.hide('modalItemDetail')
        this.onClear()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/operational/pci/lpu/addItemDetail.vue